export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  publishedAt: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '独家：某顶流男星深夜密会神秘女子，酒店共度八小时',
    excerpt: '据知情人士透露，该顶流男星近期频繁出现在某高端酒店，与其同行女子举止亲密，引发广泛关注。本社独家获取现场画面，还原事件真相。',
    content: `<h2>深夜密会细节曝光</h2>
<p>据本社独家消息，娱乐圈某顶流男星（以下称A某）于上周末深夜时分现身北京某五星级酒店地下车库，与一名身着黑色连衣裙的神秘女子一同进入电梯。两人全程保持距离，但知情人士透露，该女子与A某关系非同一般。</p>
<p>A某近年事业如日中天，主演的多部影视作品票房口碑双丰收，粉丝数量更是突破五千万大关。此前A某一直以"单身贵族"形象示人，多次在公开场合表示专注事业、暂无恋爱计划。</p>
<h2>酒店监控记录全过程</h2>
<p>据酒店内部监控记录显示，A某于当晚23:15独自驾车进入地下车库，约十分钟后，神秘女子从另一入口进入。两人在B2层会合后，由A某的助理刷卡进入专属电梯。监控画面显示，女子全程戴着口罩和帽子，但身形与某知名模特高度吻合。</p>
<p>次日早晨7:30左右，A某先行离开酒店，约一小时后，该女子才低调离开。整个过程中，两人共计在酒店内停留超过八小时。</p>
<h2>女方身份呼之欲出</h2>
<p>经过多方交叉比对，本社记者发现该神秘女子的体态特征与近期频繁出现在A某社交圈的超模C小姐高度一致。C小姐曾在今年三月的时装周上与A某有过近距离互动，当时就引发过粉丝热议。</p>
<p>目前A某工作室对此事暂无回应，本社将持续关注事件发展。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    image: 'https://readdy.ai/api/search-image?query=High-end%20hotel%20corridor%20with%20dim%20moody%20lighting%20at%20night%2C%20paparazzi%20style%20photography%2C%20mysterious%20atmosphere%2C%20luxury%20hotel%20interior%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20noir%20aesthetic%2C%20dark%20tones%20with%20warm%20accent%20lighting&width=800&height=500&seq=article-ent-01&orientation=landscape',
    author: '黑料社调查组',
    publishedAt: '2026-08-06',
    views: 128500,
    comments: 3420,
    tags: ['顶流男星', '深夜密会', '酒店', '娱乐圈'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-2',
    title: '头部女主播涉嫌偷税被调查，涉案金额高达数千万',
    excerpt: '税务部门近日对多位头部网红主播展开税务稽查，其中某平台一姐级主播被曝涉嫌偷逃税款数千万元，或将面临巨额罚款和封禁处罚。',
    content: `<h2>税务风暴席卷直播圈</h2>
<p>继去年多位头部主播被查后，税务部门于近日再次出手，对直播行业的税收乱象进行专项整治。据可靠消息，此次行动涉及至少五位千万级粉丝的女主播，其中一位拥有超过三千万粉丝的平台一姐级主播D某情况最为严重。</p>
<p>消息人士透露，D某通过设立多家空壳公司、虚报成本、个人收入转换为企业收入等方式，涉嫌在2024-2025年度偷逃个人所得税及增值税合计超过四千万元。</p>
<h2>平台紧急切割</h2>
<p>D某所在的直播平台已在内部下达封口令，要求全体员工不得对外透露任何相关信息。同时，平台技术部门正在对D某的直播回放和短视频内容进行紧急审查，为可能的封禁做准备。</p>
<p>业内人士分析认为，一旦D某偷税事实被确认，不仅将面临补缴税款和巨额罚款，其全网账号也将被永久封禁，商业代言和品牌合作也将全部终止。</p>
<h2>直播行业洗牌在即</h2>
<p>此次税务稽查行动被业内视为直播行业规范化的重要信号。监管部门或将借此机会推动建立主播收入申报系统和平台代扣代缴机制，从源头杜绝偷逃税行为。对于广大中小主播而言，这既是一次警醒，也是行业走向健康发展的契机。</p>`,
    category: '网红圈',
    categorySlug: 'influencers',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20live%20streaming%20studio%20with%20professional%20ring%20light%20and%20expensive%20equipment%2C%20empty%20chair%20in%20center%2C%20dramatic%20contrast%20lighting%2C%20moody%20atmosphere%2C%20investigative%20journalism%20style%2C%20dark%20and%20serious%20tone%2C%20cinematic%20photography&width=800&height=500&seq=article-inf-01&orientation=landscape',
    author: '黑料社财经组',
    publishedAt: '2026-08-05',
    views: 98300,
    comments: 2850,
    tags: ['女主播', '偷税', '直播圈', '税务稽查'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-3',
    title: '知名互联网公司CEO涉嫌内幕交易，证监会已立案调查',
    excerpt: '某纳斯达克上市中概股公司CEO被曝在公司发布重大利空前大量减持股票，涉嫌内幕交易，中国证监会和美国SEC均已介入调查。',
    content: `<h2>减持时间点引发质疑</h2>
<p>据本社调查发现，某知名互联网公司（以下称X公司）CEO张某某在公司发布2026年第二季度业绩预警公告前一周，通过大宗交易方式减持了价值约2.3亿美元的股票。而业绩预警发布后，X公司股价单日暴跌超过15%，市值蒸发超百亿美元。</p>
<p>这一精准的减持时机引发了投资界的广泛质疑。多位证券律师表示，如果张某某在知晓业绩预警信息的情况下提前减持，将构成严重的内幕交易行为。</p>
<h2>中美监管联手行动</h2>
<p>消息人士透露，中国证监会已对张某某涉嫌内幕交易一案正式立案调查。与此同时，美国证券交易委员会（SEC）也通过中美审计监管合作机制获取了相关交易记录，可能同时对张某某发起调查。</p>
<p>如果罪名成立，张某某可能面临最高十年的监禁和巨额罚款。此外，X公司也可能因此面临集体诉讼和监管处罚。</p>
<h2>公司紧急公关</h2>
<p>X公司公关部门已紧急启动危机公关预案，对外宣称张某某的减持行为系"个人财务规划需要"，与公司业绩无关。但这一说法并未获得投资者和媒体的认可。</p>
<p>目前X公司股价仍在持续下跌，市场信心遭受严重打击。本社将持续跟踪事件进展。</p>`,
    category: '商业圈',
    categorySlug: 'business',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20at%20dusk%20with%20dramatic%20cloudscape%2C%20financial%20district%20skyline%2C%20dark%20moody%20atmosphere%2C%20glass%20skyscraper%20reflection%2C%20serious%20business%20investigative%20tone%2C%20cinematic%20wide%20shot%2C%20professional%20photography&width=800&height=500&seq=article-biz-01&orientation=landscape',
    author: '黑料社商业组',
    publishedAt: '2026-08-04',
    views: 76500,
    comments: 1920,
    tags: ['CEO', '内幕交易', '证监会', '互联网公司'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-4',
    title: '某知名导演被多名女演员实名举报性骚扰',
    excerpt: '三位女演员联合实名举报某知名导演在片场多次实施性骚扰行为，并利用职务之便进行权势压迫，目前警方已介入调查。',
    content: `<h2>联合声明引爆舆论</h2>
<p>本周三，三位青年女演员通过律师联合发表声明，实名举报知名导演王某某（化名）在多个剧组拍摄期间对她们实施性骚扰。声明详细列举了多起具体事件，时间跨度从2023年至2025年。</p>
<p>三位女演员在声明中表示："我们选择站出来，不仅是为了自己讨回公道，更是希望这个行业不再有下一个受害者。"声明发布后，相关话题迅速登上微博热搜榜首，阅读量在六小时内突破五亿。</p>
<h2>圈内人士纷纷发声</h2>
<p>事件曝光后，多位圈内知名人士公开发声支持举报者。著名制片人李某在社交媒体发文："这个行业需要阳光，需要正义。"某金马奖影后也表示："打破沉默需要巨大的勇气，向她们致敬。"</p>
<p>但也有部分业内人士选择沉默或以"不了解情况"为由拒绝评论，引发公众质疑。</p>
<h2>导演方面否认指控</h2>
<p>王某某方面通过律师发表声明，全盘否认所有指控，称这是"别有用心的恶意诽谤"，并表示将"通过法律途径维护自身合法权益"。</p>
<p>目前，北京警方已正式受理此案并展开调查。业内人士预计，此事件将对影视圈的权力结构产生深远影响。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20professional%20movie%20camera%20on%20tripod%2C%20dramatic%20spotlight%20effect%2C%20moody%20dark%20atmosphere%2C%20empty%20director%20chair%2C%20backstage%20of%20cinema%20production%2C%20serious%20investigative%20tone%2C%20cinematic%20noir%20lighting%2C%20shadows%20and%20contrast&width=800&height=500&seq=article-ent-02&orientation=landscape',
    author: '黑料社调查组',
    publishedAt: '2026-08-03',
    views: 215000,
    comments: 8760,
    tags: ['导演', '性骚扰', '实名举报', '影视圈'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-5',
    title: '某知名MCN机构被曝数据造假，千万粉账号实际活粉不足十万',
    excerpt: '第三方监测机构报告显示，某头部MCN机构旗下多个千万级粉丝账号存在严重数据造假，真实活跃粉丝不足标称的百分之一。',
    content: `<h2>数据水分触目惊心</h2>
<p>独立第三方数据监测机构"真数科技"近日发布了一份调查报告，指出某知名MCN机构旗下超过二十个拥有"千万粉丝"的头部账号存在严重的数据造假行为。报告显示，这些账号的真实日活跃粉丝数平均仅为标称粉丝数的0.5%至3%。</p>
<p>以其中一个拥有三千万粉丝的头部账号为例，其单条视频的平均真实互动量不足一万，与标称粉丝量严重不符。更令人震惊的是，该账号超过百分之八十的评论和点赞来自疑似机器人账号。</p>
<h2>品牌方损失惨重</h2>
<p>据不完全统计，过去一年中，至少有五十余个品牌与该MCN机构旗下账号进行过商业合作，总投放金额超过两亿元。多位品牌方负责人在得知数据造假消息后表示愤怒和无奈。</p>
<p>某美妆品牌市场总监表示："我们花了几百万投了一个所谓的千万粉账号，结果ROI低得离谱。现在终于明白是为什么了。"</p>
<h2>平台表态将严查</h2>
<p>各大内容平台纷纷表态将加强对MCN机构和头部账号的数据监管。某短视频平台安全负责人表示，将引入更先进的AI反作弊系统，对数据造假行为"零容忍"。</p>
<p>业内专家建议品牌方在进行KOL投放时，不应仅看粉丝数量，更应关注账号的真实互动率和粉丝画像。</p>`,
    category: '网红圈',
    categorySlug: 'influencers',
    image: 'https://readdy.ai/api/search-image?query=Digital%20analytics%20dashboard%20on%20dark%20screen%20showing%20fake%20follower%20statistics%2C%20glowing%20graphs%20and%20charts%2C%20dimly%20lit%20modern%20office%2C%20cyber%20investigation%20mood%2C%20hacker%20aesthetic%2C%20neon%20accent%20lighting%2C%20serious%20tech%20atmosphere&width=800&height=500&seq=article-inf-02&orientation=landscape',
    author: '黑料社数据组',
    publishedAt: '2026-08-02',
    views: 89000,
    comments: 3210,
    tags: ['MCN', '数据造假', '网红', '粉丝'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-6',
    title: '明星直播带货翻车：声称"纯天然"产品被检出违禁成分',
    excerpt: '知名女星直播间推荐的"纯天然草本减肥茶"被消费者送检后发现含有违禁药物成分，目前市场监管局已介入调查。',
    content: `<h2>明星背书的产品出事了</h2>
<p>本月初，知名女星刘某在其直播间大力推荐的一款"纯天然草本减肥茶"被多名消费者反映在饮用后出现心悸、失眠、恶心等不适症状。三位消费者将产品送至第三方检测机构化验后，发现该产品含有国家明令禁止添加的西布曲明成分。</p>
<p>西布曲明是一种中枢神经抑制剂，曾被用于减肥药物，但因会增加心脑血管疾病风险，我国早在2010年就已禁止生产和销售含该成分的减肥类产品。</p>
<h2>刘某推卸责任惹众怒</h2>
<p>事件曝光后，刘某在社交平台发布声明，称自己只是"正常进行商业推广"，对产品质量"不知情"，并将责任全部推给品牌方。这一表态引发了消费者的强烈不满。</p>
<p>法律专家指出，根据《广告法》和《食品安全法》相关规定，明星作为产品代言人，对所代言的产品负有审查义务。如果产品存在问题，代言人需要承担相应的法律责任。</p>
<h2>监管重拳出击</h2>
<p>目前，北京、上海、广州三地市场监管部门已联合对该减肥茶品牌立案调查。刘某的社交账号也被平台临时限制商业推广功能。业内人士认为，此次事件或将推动直播带货行业建立更严格的选品和审核机制。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20setup%20with%20ring%20light%20and%20smartphone%20on%20tripod%2C%20beauty%20and%20health%20products%20on%20table%2C%20dramatic%20spotlight%2C%20dark%20background%2C%20investigative%20journalism%20mood%2C%20cinematic%20lighting%2C%20warm%20and%20cool%20contrast&width=800&height=500&seq=article-ent-03&orientation=landscape',
    author: '黑料社消费组',
    publishedAt: '2026-08-01',
    views: 156000,
    comments: 6540,
    tags: ['直播带货', '翻车', '明星', '违禁成分'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-7',
    title: '独家：某投资人爆料科技独角兽公司财务造假全过程',
    excerpt: '一位匿名投资人向本社提供了某估值百亿的科技独角兽公司系统性财务造假的内部证据，涉及虚增收入、伪造合同等多项严重问题。',
    content: `<h2>百亿估值下的暗箱操作</h2>
<p>本社近日获得了一份由匿名投资人提供的内部资料，详细记录了某科技独角兽公司（以下称Y公司）在2024至2025年间的系统性财务造假行为。Y公司对外宣称估值已超过百亿美元，是行业内备受瞩目的明星企业。</p>
<p>资料显示，Y公司通过虚构客户合同、虚增营业收入、隐瞒关联交易等手段，将实际不到五亿元的年营收夸大了近十倍。其中一份标注为"内部参考"的财务对照表明确显示，对外披露数据与内部真实数据存在巨大差异。</p>
<h2>投资机构集体踩雷</h2>
<p>据悉，Y公司在过去两年中完成了三轮融资，累计融资额超过十五亿美元，投资方包括多家国际顶级风投机构。如果财务造假被证实，这些机构的投资将面临严重减值。</p>
<p>某参与投资Y公司的基金合伙人在接受本社采访时表示"不愿置评"，但承认"正在密切关注此事"。</p>
<h2>IPO计划或将被无限期搁置</h2>
<p>Y公司原计划于今年第三季度在纳斯达克提交IPO申请，目标估值两百亿美元。但随着造假消息的发酵，其IPO计划或将无限期搁置。投行人士分析认为，即便造假指控最终被澄清，Y公司的上市进程也将至少推迟一年。</p>`,
    category: '商业圈',
    categorySlug: 'business',
    image: 'https://readdy.ai/api/search-image?query=Financial%20documents%20and%20spreadsheets%20scattered%20on%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20mysterious%20atmosphere%2C%20corporate%20investigation%20theme%2C%20shadows%20and%20contrast%2C%20cinematic%20noir%20style%2C%20serious%20business%20photography&width=800&height=500&seq=article-biz-02&orientation=landscape',
    author: '黑料社商业组',
    publishedAt: '2026-07-31',
    views: 67000,
    comments: 1850,
    tags: ['独角兽', '财务造假', '投资', '科技公司'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-8',
    title: '热点追踪：某城市拆迁纠纷升级，居民与开发商爆发激烈冲突',
    excerpt: '某二线城市一老旧小区的拆迁补偿纠纷持续升级，数十户居民与开发商保安发生肢体冲突，多名居民受伤送医，警方已介入处置。',
    content: `<h2>拆迁补偿谈了三年未果</h2>
<p>据本社记者前方报道，Z市核心地段的一个老旧小区的拆迁纠纷已持续三年有余。开发商给出的补偿标准为每平方米一万二千元，而居民认为参照周边新房三万元以上的售价，该补偿标准严重偏低。</p>
<p>小区共有住户三百余户，其中约两百户已在过去两年中陆续签约搬离，但仍有近百户居民拒绝接受现有补偿方案，坚持要求"原地回迁"或提高补偿标准。</p>
<h2>冲突在凌晨爆发</h2>
<p>昨日凌晨五时许，开发商组织的施工队和数十名保安人员突然进入小区，试图对一栋仍有居民居住的楼栋进行拆除作业。居民发现后迅速聚集阻止，双方随即爆发肢体冲突。</p>
<p>现场视频显示，多名保安对居民进行了推搡和拖拽，至少有五名老年居民在冲突中倒地受伤，被120急救车送往医院。一名目击者描述："他们就像对待敌人一样对待这些老人，太让人心寒了。"</p>
<h2>政府紧急介入</h2>
<p>事件发生后，当地政府部门紧急介入，约谈了开发商负责人，并承诺将重新评估拆迁补偿方案。同时，警方已对冲突事件立案调查，将依法追究相关人员的责任。</p>
<p>本社记者将持续关注事件进展，为读者带来最新报道。</p>`,
    category: '热点事件',
    categorySlug: 'hot-events',
    image: 'https://readdy.ai/api/search-image?query=Old%20residential%20building%20complex%20in%20Chinese%20city%20at%20dawn%2C%20dramatic%20lighting%2C%20tension%20in%20the%20air%2C%20documentary%20photography%20style%2C%20urban%20development%20contrast%2C%20gritty%20realistic%20atmosphere%2C%20serious%20social%20issue%20theme&width=800&height=500&seq=article-hot-01&orientation=landscape',
    author: '黑料社社会组',
    publishedAt: '2026-07-30',
    views: 234000,
    comments: 12500,
    tags: ['拆迁', '冲突', '社会事件', '居民权益'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-9',
    title: '某选秀节目被曝内定冠军，赞助商施压节目组改票',
    excerpt: '正在热播的某大型选秀节目被曝存在严重黑幕，赞助商为推广自家签约选手，多次向节目组施压要求调整投票结果。',
    content: `<h2>选秀节目还是选钱节目？</h2>
<p>本社获取了一份据称来自某选秀节目内部工作人员提供的录音和聊天记录，显示该节目的冠名赞助商多次向节目组施压，要求为其签约的三位选手提供更多镜头和"便利"。</p>
<p>录音中，赞助商代表明确表示："我们投了几个亿，如果我们的选手拿不到好名次，明年的赞助就别谈了。"节目组执行总导演则回应："我们尽量安排，但也不能太明显。"</p>
<h2>投票数据异常引质疑</h2>
<p>细心的观众发现，该节目最近两期的投票数据存在明显异常。某位原本排名靠后的选手在一夜之间票数暴涨三百万，超越了多位人气选手，而节目组对此的解释是"海外粉丝集中投票"。</p>
<p>数据分析师指出，该选手的票数增长曲线存在明显的人为干预痕迹，不符合正常的粉丝投票规律。这一发现进一步加剧了公众对节目公正性的质疑。</p>
<h2>广电总局或将出手</h2>
<p>消息人士透露，国家广电总局已注意到相关举报，正在评估是否对该节目进行专项调查。如果黑幕被证实，该节目可能面临停播整改的处罚。</p>
<p>近年来，广电总局已多次发文规范选秀节目的投票和评审机制，此次事件或将推动更严格的行业监管。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20empty%20judge%20panel%2C%20backstage%20area%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20entertainment%20industry%20behind%20the%20scenes%2C%20cinematic%20lighting%20with%20shadows%2C%20dark%20and%20moody%20tone&width=800&height=500&seq=article-ent-04&orientation=landscape',
    author: '黑料社调查组',
    publishedAt: '2026-07-29',
    views: 187000,
    comments: 7890,
    tags: ['选秀', '内定', '黑幕', '赞助商'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-10',
    title: '揭秘："气功大师"诈骗团伙落网，敛财数十亿的惊天骗局',
    excerpt: '一个以"气功治病""能量石"为幌子的诈骗团伙近日被警方一网打尽，该团伙在全国各地发展下线，涉案金额高达数十亿元。',
    content: `<h2>"大师"的真面目</h2>
<p>经过为期半年的侦查，警方于近日在全国多个省市同步收网，将一个以"气功大师"陈某为首的诈骗团伙一网打尽，抓获犯罪嫌疑人八十余名，冻结涉案资金超过十二亿元。</p>
<p>现年五十六岁的陈某仅有初中学历，早年在街头摆摊算卦为生。2018年起，陈某开始在短视频平台发布"气功演示"视频，声称能够通过"能量传递"治疗各种疑难杂症，迅速积累了数百万粉丝。</p>
<h2>层层套路骗取信任</h2>
<p>据警方调查，该团伙的诈骗手法规模化、体系化。首先通过短视频和线上直播吸引粉丝，然后以"免费会诊"为名获取个人信息，再以"能量石""开光法器"等道具高价销售，最后诱导受害者参加"高级研修班"，收费从数万元到数十万元不等。</p>
<p>在该团伙的受害者中，既有身患重病求医无门的普通百姓，也有高学历的企业高管和退休干部。一位受害者家属哭诉："我父亲把养老的房子都卖了，就为了买那个所谓的能量石。"</p>
<h2>平台责任引发讨论</h2>
<p>此案曝光后，短视频平台的内容审核机制再次成为舆论焦点。多位法律专家呼吁平台应加强对涉及医疗健康类内容的审核，建立更严格的主播资质认证制度，以防止类似骗局再次发生。</p>`,
    category: '热点事件',
    categorySlug: 'hot-events',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20spiritual%20healing%20room%20with%20crystals%20and%20incense%2C%20dramatic%20chiaroscuro%20lighting%2C%20deceptive%20mystical%20atmosphere%2C%20investigative%20journalism%20mood%2C%20dark%20shadows%2C%20cult-like%20setting%2C%20serious%20documentary%20photography%20style&width=800&height=500&seq=article-hot-02&orientation=landscape',
    author: '黑料社社会组',
    publishedAt: '2026-07-28',
    views: 312000,
    comments: 15600,
    tags: ['气功大师', '诈骗', '团伙', '社会事件'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-11',
    title: '某知名餐饮连锁品牌被曝光后厨卫生触目惊心',
    excerpt: '暗访记者在某知名连锁火锅品牌后厨拍下惊人画面：老鼠横行、食材过期仍在使用、洗碗水反复使用，引发全网震惊。',
    content: `<h2>卧底暗访揭露真相</h2>
<p>本社记者经过长达一个月的卧底暗访，在某知名连锁火锅品牌（以下称H火锅）的北京某门店后厨拍摄到了令人震惊的画面。这些画面显示，该门店存在严重的食品安全隐患。</p>
<p>暗访视频中，后厨操作间的墙角有明显的鼠洞，夜间有老鼠在食材储存区出没。更令人发指的是，部分标注保质期的食材已过期数日，但后厨人员仍然继续使用。洗碗区域的工作人员将洗碗水反复使用，水质已呈现浑浊的黄褐色。</p>
<h2>品牌方紧急道歉但消费者不买账</h2>
<p>报道发布后，H火锅迅速登上各大平台热搜。品牌方在舆论压力下，于四小时后发布道歉声明，称"深感痛心和愧疚"，并承诺将涉事门店立即停业整改、对全国门店开展卫生大检查。</p>
<p>然而，这一道歉并未平息消费者的愤怒。大量网友在品牌官方账号下留言要求"退还会员卡余额"，多地消费者协会也收到了相关投诉。法律人士指出，H火锅可能面临巨额行政处罚和消费者集体诉讼。</p>
<h2>行业警示</h2>
<p>此次事件再次敲响了餐饮行业食品安全的警钟。业内专家呼吁建立更严格的"明厨亮灶"制度和常态化抽查机制，让消费者真正吃得放心。</p>`,
    category: '热点事件',
    categorySlug: 'hot-events',
    image: 'https://readdy.ai/api/search-image?query=Dark%20and%20dirty%20commercial%20kitchen%20backroom%2C%20dramatic%20single%20light%20source%2C%20messy%20food%20preparation%20area%2C%20investigative%20undercover%20photography%2C%20gritty%20realistic%20atmosphere%2C%20health%20code%20violation%20scene%2C%20serious%20documentary%20style&width=800&height=500&seq=article-hot-03&orientation=landscape',
    author: '黑料社暗访组',
    publishedAt: '2026-07-27',
    views: 289000,
    comments: 14300,
    tags: ['餐饮', '食品安全', '暗访', '后厨'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-12',
    title: '某直播平台高管涉嫌组织网络赌博被刑事拘留',
    excerpt: '某头部直播平台副总裁及多名运营负责人因涉嫌利用直播功能组织网络赌博活动，已被公安机关刑事拘留，涉案金额超过五十亿元。',
    content: `<h2>直播间的秘密赌场</h2>
<p>本社从权威渠道获悉，某头部直播平台（以下称Z平台）副总裁王某及旗下六名运营负责人已于本周一被公安机关刑事拘留。警方指控他们在2024年至2026年间，利用平台的"竞猜"和"礼物对战"功能，变相组织大规模网络赌博活动。</p>
<p>据调查，用户通过充值购买虚拟礼物参与竞猜，获胜方可以将礼物变现。这种模式表面上是平台互动功能，实质上是典型的赌博行为。警方初步统计，涉案金额高达五十亿元以上，涉及用户超过百万人。</p>
<h2>平台切割试图自保</h2>
<p>事发后，Z平台紧急发表声明，将王某等人的行为定性为"个人违规行为"，声称平台"对此不知情"，并宣布已暂停王某的职务。但这一"弃车保帅"的做法并未获得外界认可。</p>
<p>一位不愿透露姓名的前Z平台员工告诉本社："'竞猜'功能从立项到上线，每个环节都需要高层审批，说不知情谁信？"</p>
<h2>监管风暴将至</h2>
<p>多位行业分析师认为，Z平台事件可能引发对整个直播行业的全面整顿。监管部门或将出台新的法规，对直播平台的互动功能进行更严格的界定和管控。对于依赖"打赏经济"的直播平台来说，这无疑是一次巨大的冲击。</p>`,
    category: '商业圈',
    categorySlug: 'business',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20at%20night%20with%20police%20warning%20tape%20across%20server%20room%20door%2C%20dramatic%20blue%20and%20red%20emergency%20lighting%2C%20cyber%20crime%20investigation%20atmosphere%2C%20corporate%20headquarters%20after%20raid%2C%20serious%20documentary%20photography%2C%20tension%20and%20drama&width=800&height=500&seq=article-biz-03&orientation=landscape',
    author: '黑料社商业组',
    publishedAt: '2026-07-26',
    views: 198000,
    comments: 8760,
    tags: ['直播平台', '赌博', '刑事拘留', '高管'],
    isHot: true,
    isFeatured: false,
  },
];

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id) || null;
};

export const getArticlesByCategory = (slug: string) => {
  return articles.filter((a) => a.categorySlug === slug);
};

export const getHotArticles = () => {
  return articles.filter((a) => a.isHot);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.isFeatured);
};

export const getLatestArticles = (count: number = 6) => {
  return [...articles]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, count);
};

export const getRelatedArticles = (currentId: string, categorySlug: string, count: number = 4) => {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, count);
};